import React, { Component } from "react";
import "./Header.css";
import { NavLink, withRouter } from "react-router-dom";
import classNames from "classnames";
import { connect } from "react-redux";
import { routeCodes } from "../../config/routes";
import { setLanguage } from "../../actions/actions";
import logo from "../../assets/images/logo.png";
import logo2 from "../../assets/images/logo2.png";
import search from "../../assets/images/search.svg";
import Menu from "../Menu";
import deconstructed from "../../assets/images/deconstructed.png";

const designer = {
  Srpski: "Dizajner",
  English: "Designer",
  Italian: "Designer"
};

const atelier = {
  Srpski: "Atelje",
  English: "Atelier",
  Italian: "Atelier"
};

const collections = {
  Srpski: "Kolekcije",
  English: "Collections",
  Italian: "Collezioni"
};

const news = {
  Srpski: "Vesti",
  English: "News",
  Italian: "Notizie"
};

const contact = {
  Srpski: "Kontakt",
  English: "Contact",
  Italian: "Contatto"
};

class Header extends Component {
  constructor() {
    super();
    this.state = {
      placeholder: {
        Srpski: "",
        English: "",
        Italian: ""
      },
      scrollPosition: 0,
      inputValue: null,
      noResults: false,
      results: null,
      activeMenu: false
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    document.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    const { scrollPosition } = this.state;
    const windowScroll = window.scrollY || window.pageYOffset;
    const isScrollingDown = windowScroll > scrollPosition;
    this.setState({
      direction: isScrollingDown ? "bottom" : "top",
      scrollPosition: windowScroll
    });
  }

  handleSearchInputChange(event) {
    const inputValue = event.target.value.toLowerCase();
    this.setState({
      inputValue: inputValue
    });
    this.filterResults(inputValue);
  }

  filterResults(inputValue) {
    const triggerPoint = 4;
    const data = this.props.data.singleCollection;
    const newsData = this.props.data.news;
    const { language } = this.props;
    if (inputValue.length >= triggerPoint) {
      const results = data.filter(i => {
        return i.title[language].toLowerCase().includes(inputValue);
      });
      const newsResults = newsData.filter(i => {
        return i.title.toLowerCase().includes(inputValue);
      });
      const allData = [results, newsResults];
      const hasAnyResult = allData
        .map(data => {
          return data.length;
        })
        .some(length => length > 0);
      if (hasAnyResult) {
        this.setState({
          results: allData,
          noResults: false
        });
      } else {
        this.setState({
          results: null,
          noResults: true
        });
      }
    } else {
      this.setState({
        results: null,
        noResults: false
      });
    }
  }

  renderResults() {
    const { results } = this.state;
    const { language } = this.props;
    const { singleCollection } = this.props.data;
    return results
      ? results.map((sectionItem, sectionIndex) => {
          const shouldShow = sectionItem.length > 0;
          const isNews = sectionIndex === 1;
          return (
            shouldShow &&
            sectionItem.map((item, index) => {
              const collectionsIndex =
                !isNews &&
                singleCollection.findIndex(
                  x => x.title[language] === item.title[language]
                );
              return (
                <NavLink
                  className="Header-result"
                  key={index}
                  onClick={() => this.handleNavLinkClick(index)}
                  to={
                    isNews
                      ? {
                          pathname: routeCodes.PIECEOFNEWS,
                          state: { data: item }
                        }
                      : {
                          pathname: routeCodes.COLLECTION,
                          state: { page: collectionsIndex }
                        }
                  }
                >
                  <p className="Header-result--name">
                    {isNews ? item.title[language] : item.title[language]}
                  </p>
                </NavLink>
              );
            })
          );
        })
      : null;
  }

  handleNavLinkClick() {
    this.scrollToTop();
    document.querySelector(".HeaderInput").value = "";
    this.setState({
      results: null
    });
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  toggleMenu() {
    const { activeMenu } = this.state;
    const HTML = document.querySelector("html");
    const BODY = document.querySelector("body");
    this.setState({
      activeMenu: !activeMenu
    });
    this.scrollToTop();
    if (!activeMenu) {
      HTML.classList.add("noScrollable");
      BODY.classList.add("noScrollable");
      this.scrollToTop();
    } else {
      HTML.classList.remove("noScrollable");
      BODY.classList.remove("noScrollable");
    }
  }

  closeMenu() {
    this.setState({
      activeMenu: false
    });
    const HTML = document.querySelector("html");
    const BODY = document.querySelector("body");
    HTML.classList.remove("noScrollable");
    BODY.classList.remove("noScrollable");
  }

  render() {
    const { language, dispatch } = this.props;
    const {
      results,
      noResults,
      activeMenu,
      direction,
      scrollPosition
    } = this.state;
    const height = window.innerHeight;
    const animatedHeader =
      direction === "bottom" && scrollPosition > height * 1.1;
    const updateLogo = scrollPosition > height / 3;
    const headerClasses = classNames(
      "Header",
      animatedHeader && "Header--animated"
    );

    const logoClasses = classNames("Logo", updateLogo && "Logo-hidden");

    const logo2Classes = classNames(
      "Logo2-hidden Logo",
      updateLogo && "Logo-visible"
    );

    const headerRightClasses = classNames(
      "Header-right--mobile",
      activeMenu && "Header-right--mobileActive"
    );

    const langClasses = classNames(
      "ButtonLang",
      language === "English" && "ButtonLang--active"
    );

    const srbLangClasses = classNames(
      "ButtonLang",
      language === "Srpski" && "ButtonLang--active"
    );

    const itLangClasses = classNames(
      "ButtonLang",
      language === "Italian" && "ButtonLang--active"
    );

    return (
      <div className={headerClasses}>
        <Menu closeMenu={() => this.closeMenu()} activeMenu={activeMenu} />
        <div className="Header-Left">
          <div className="LanguagesMobile">
            <button
              className={srbLangClasses}
              onClick={() => dispatch(setLanguage("Srpski"))}
            >
              SR
            </button>
            <button
              className={langClasses}
              onClick={() => dispatch(setLanguage("English"))}
            >
              EN
            </button>
            <button
              className={itLangClasses}
              onClick={() => dispatch(setLanguage("Italian"))}
            >
              IT
            </button>
          </div>
          <NavLink
            onClick={() => this.scrollToTop()}
            to={{ pathname: routeCodes.HOME_PAGE }}
          >
            <img className="LogoMobile" src={logo2} alt="Igor Atelier" />
          </NavLink>
          <div className="Search">
            <img src={search} alt="search" />
            <input
              className="HeaderInput"
              onChange={event => this.handleSearchInputChange(event)}
              placeholder={this.state.placeholder[language]}
            />
            {!animatedHeader &&
              results && (
                <div className="Header-results">{this.renderResults()}</div>
              )}
            {!animatedHeader &&
              noResults && <p className="No-results">no results</p>}
          </div>
        </div>
        <div className="Header-Center">
          <div className="Header-Center-Left">
            <NavLink
              onClick={() => this.scrollToTop()}
              to={routeCodes.DESIGNER}
            >
              {designer[language]}
            </NavLink>
            <NavLink onClick={() => this.scrollToTop()} to={routeCodes.ATELIER}>
              {atelier[language]}
            </NavLink>
            <NavLink
              onClick={() => this.scrollToTop()}
              to={routeCodes.COLLECTIONS}
            >
              {collections[language]}
            </NavLink>
          </div>
          <div className="Header-Center-Central">
            <NavLink
              onClick={() => this.scrollToTop()}
              to={{ pathname: routeCodes.HOME_PAGE }}
            >
              <img className={logoClasses} src={logo} alt="Igor Atelier" />
              <img className={logo2Classes} src={logo2} alt="Igor Atelier" />
            </NavLink>
          </div>
          <div className="Header-Center-Right">
            <NavLink onClick={() => this.scrollToTop()} to={routeCodes.NEWS}>
              {news[language]}
            </NavLink>
            <NavLink onClick={() => this.scrollToTop()} to={routeCodes.CONTACT}>
              {contact[language]}
            </NavLink>
            <NavLink
              onClick={() => this.scrollToTop()}
              to={routeCodes.DECONSTRUCTED}
            >
              <img
                className="deconstructedLogo"
                src={deconstructed}
                alt="Deconstructed"
              />
            </NavLink>
          </div>
        </div>
        <div className="Header-Right">
          <button
            className={headerRightClasses}
            onClick={() => this.toggleMenu()}
          >
            <span className="BurgerSpan BurgerSpan-top" />
            <span className="BurgerSpan BurgerSpan-center" />
            <span className="BurgerSpan BurgerSpan-bottom" />
          </button>
          <div className="Languages">
            <button
              className={srbLangClasses}
              onClick={() => dispatch(setLanguage("Srpski"))}
            >
              SR
            </button>
            <button
              className={langClasses}
              onClick={() => dispatch(setLanguage("English"))}
            >
              EN
            </button>
            <button
              className={itLangClasses}
              onClick={() => dispatch(setLanguage("Italian"))}
            >
              IT
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language
  };
}

export default withRouter(connect(mapStateToProps)(Header));



// WEBPACK FOOTER //
// ./src/components/Header/index.js